import { UserContext, type UserContextType } from "@/contexts/user";
import { graphql } from "@/gql";
import { useTokenStore } from "@/store/token";
import { useQuery } from "@/utils/graphql";
import { Spin } from "antd";
import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet } from "react-router";

export const getUserDetails = graphql(`
  query GetUserDetails {
    personal_user {
      id
      createdOn
      isValid
      isAdmin
      lastLogin
      lastUpdate
      name
    }
  }
`);
export function ProtectedRoute({ children }: { children?: ReactNode }) {
  const { t } = useTranslation();
  const { isAuthenticated } = useTokenStore();
  const { data, isLoading, error } = useQuery(getUserDetails, {});
  const user = data?.personal_user;
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spin size="large" description={t("common.loading")}>
          <div className="min-w-60" />
        </Spin>
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (error) {
    console.error("Error fetching user details:", error);
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p>{t("common.error")}</p>
      </div>
    );
  }

  const contextValue: UserContextType = {
    currentUser: user,
    isAdmin: user?.isAdmin || false,
  };
  if (!user?.isValid) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <UserContext.Provider value={contextValue}>
      {children || <Outlet />}
    </UserContext.Provider>
  );
}
